import { httpRequest } from "../../http";

/** Ops bulk processing (MPN-1445): validate + load every uploaded file for the
 *  definition in file-as_of order (fail-fast — one bad file stops the batch
 *  before anything loads). Returns the background job id. */
export class CommandProcessPendingFiles {
  async run(definitionId: number): Promise<{ job_id: number }> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/definitions/${definitionId}/process-pending/`;
    return httpRequest<{ job_id: number }>(url, { method: "POST" });
  }
}
